<template>
  <transition name="fade">
    <div class="verify-mask" v-show="showBox" @click.self="onClose">
      <div class="verifybox">
        <div class="verifybox-bottom">
          <VerifySlider
            @success="onSuccess"
            @error="onError"
            captchaType="blockPuzzle"
            :imgSize="imgSize"
            ref="verify"
          />
        </div>
      </div>
    </div>
  </transition>
</template>
<script>
import VerifySlider from "./VerifySlider.vue";

export default {
  name: "VerifyPopup",
  props: {
    captchaType: {
      type: String,
      default: "blockPuzzle"
    },
    imgSize: {
      type: Object,
      default() {
        return { width: "310px", height: "155px" };
      }
    }
  },
  components: {
    VerifySlider
  },
  data() {
    return {
      showBox: false
    };
  },
  methods: {
    show() {
      this.showBox = true;
      document.body.style.overflow = "hidden";
      this.$nextTick(() => {
        this.refresh();
      });
    },
    hide() {
      this.showBox = false;
      document.body.style.overflow = "";
    },
    onClose() {
      this.hide();
      this.$emit("close");
    },
    onSuccess(data) {
      this.$emit("success", data);
      setTimeout(() => {
        this.hide();
      }, 800);
    },
    onError() {
      // 验证失败，组件内部会自动刷新
    },
    refresh() {
      if (this.$refs.verify) {
        this.$refs.verify.refresh();
      }
    }
  }
};
</script>
<style scoped>
.verify-mask {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1001;
  width: 100%;
  height: 100vh;
  background: rgba(0, 0, 0, 0.3);
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}
.verifybox {
  position: relative;
  box-sizing: border-box;
  border-radius: 8px;
  border: 1px solid #e4e7eb;
  background-color: #fff;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
  width: 340px;
  max-width: 90%;
}
.verifybox-top {
  padding: 0 15px;
  height: 50px;
  line-height: 50px;
  text-align: left;
  font-size: 16px;
  color: #45494c;
  border-bottom: 1px solid #e4e7eb;
  box-sizing: border-box;
  position: relative;
}
.verifybox-bottom {
  padding: 15px;
  box-sizing: border-box;
}
.verifybox-close {
  position: absolute;
  top: 13px;
  right: 9px;
  width: 24px;
  height: 24px;
  text-align: center;
  line-height: 24px;
  cursor: pointer;
  font-size: 14px;
  color: #999;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
